import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import phoneCall from "../../../src/assets/phone-call.png";
import whatsappIcon from "../../../src/assets/whatsapp.png";
import { useLanguage } from "../contextApi/languageContext";
import { FaBell } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ChatBot from "./ChatBot";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isHovered, setIsHOverd] = useState(true);
  const { language } = useLanguage();
  const navigate = useNavigate();

  const scrollToTop = () => {
    navigate("/offers");
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 20,
        left: language === "ar" ? "auto" : 10,
        right: language === "ar" ? 10 : "auto",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        zIndex: 99,
      }}
    >
      <ChatBot />

      <AnimatePresence>
        {isVisible && (
          <motion.div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            {/* Button with Bell Icon */}
            <motion.button
              onClick={scrollToTop}
              aria-label="Scroll to top"
              style={{
                width: "45px",
                height: "45px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                borderRadius: "50%",
                // backgroundColor: "#c69933",
                cursor: "pointer",
                padding: 0,
              }}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              animate={{
                rotate: [0, -15, 15, -15, 15, 0],
              }}
              transition={{
                repeat: Infinity,
                repeatDelay: 2,
                duration: 0.6,
              }}
            >
              <FaBell
                size={28}
                style={{
                  color: "#c69933",
                }}
              />
            </motion.button>
            {/* Tooltip */}
            {isHovered && (
              <>
                <motion.div
                  className="tooltip"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 }}
                >
                  Latest Offers
                </motion.div>
                <FaTimes
                  onClick={() => setIsHOverd(false)}
                  style={{
                    position: "absolute",
                    top: "-10",
                    left: "165px",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                />
              </>
            )}
          </motion.div>
        )}
      </AnimatePresence>
      <a
        href="https://wa.me/971551200086"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="whatsapp-btn"
      >
        <img
          src={whatsappIcon}
          alt="WhatsApp"
          style={{ width: "40px", height: "40px" }}
        />
      </a>

      {/* Your existing Call button (unchanged) */}
      <a
        href="tel:+971551200086"
        aria-label="Call us"
        className="phone-call-btn"
      >
        <img
          src={phoneCall}
          alt="Phone Call"
          style={{ width: "40px", height: "40px" }}
        />
      </a>

      {/* Scroll to Top Button with Horizontal Tooltip */}

      <style jsx>{`
        .tooltip {
          padding: 6px 12px;
          background-color: rgba(0, 0, 0, 0.8);
          color: white;
          border-radius: 4px;
          font-size: 18px;
          white-space: nowrap;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          z-index: 10;
        }
      `}</style>
    </div>
  );
};

export default ScrollToTop;
